import common from "./common";
import auth from "./auth";
import home from "./home";
import web from "./web";
import schedule from "./schedule";
import app from "./app";
import inventory from "./inventory";

export default {
  common,
  auth,
  home,
  web,
  schedule,
  app,
  inventory,
};
